import Cookies from "js-cookie";
import React from "react";
import styled from "styled-components";
import { API_HOST } from "../../config";
import axios from "../../modules/axiosInstance";

import Button from "../atoms/Button";
import Form from "../molecules/Form";
import FormInput from "../molecules/FormInput";
import Modal from "../molecules/Modal";

import { AdminuUserContainer } from "../../containers/AdminUserContainer";
import { IProfileEditModal } from "../../customHook/NavigationBarHook";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  modalState: IProfileEditModal;
}

const ProfileEditModal: React.FC<IProps> = ({ modalState, ...props }) => {
  const {
    profileEditForm,
    changeProfileEditForm
  } = AdminuUserContainer.useContainer();

  const validateInput = (): boolean => {
    for (const prop in profileEditForm) {
      if (prop !== "changedPassword" && profileEditForm[prop] === "") {
        alert("全ての項目を埋めてください。");
        return false;
      }
    }
    return true;
  };

  const handelEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!validateInput()) return;
    const params = new URLSearchParams();

    params.append("email", profileEditForm.email);
    params.append("password", profileEditForm.password);
    params.append("name", profileEditForm.name);
    if (profileEditForm.changedPassword !== "") {
      params.append("changedPassword", profileEditForm.changedPassword);
    }
    const admin_id = Cookies.get("admin_id");
    const url = `${API_HOST}/api/admins/${admin_id}`;
    axios
      .put(url, params)
      .then(r => {
        alert("プロフィールが変更されました。");
      })
      .catch(e => {
        alert("プロフィールの変更に失敗しました。");
      });
    modalState.close();
  };

  const changeFormEachItem = (item: string, value: string) => {
    // reference: https://reactjs.org/docs/hooks-reference.html#functional-updates
    changeProfileEditForm(prevState => {
      prevState[item] = value;
      return { ...prevState };
    });
  };

  return (
    <Modal
      {...props}
      title={"プロフィールの編集"}
      content={
        <>
          <Form>
            <FormInput
              items={[
                {
                  type: "text",
                  key: "name",
                  value: profileEditForm.name,
                  placeholder: "名前",
                  required: true
                },
                {
                  type: "email",
                  key: "email",
                  value: profileEditForm.email,
                  placeholder: "メール",
                  required: true
                },
                {
                  type: "password",
                  key: "password",
                  value: profileEditForm.password,
                  placeholder: "現在のパスワード",
                  required: true
                },
                {
                  type: "password",
                  key: "changedPassword",
                  value: profileEditForm.changedPassword,
                  placeholder:
                    "パスワードを変更したい場合は、ここに変更後のパスワードを入力してください。",
                  required: false
                }
              ]}
              onChangeEachItem={changeFormEachItem}
            />
          </Form>
          <ButtonAlign>
            <CancelButton title={"キャンセル"} onClick={modalState.close} />
            <DesideButton title={"決定"} onClick={handelEditSubmit} />
          </ButtonAlign>
        </>
      }
    />
  );
};

export default ProfileEditModal;

const ButtonAlign = styled.div`
  display: flex;
`;
const DesideButton = styled(Button)``;
const CancelButton = styled(Button)``;
